/**
 * Per-surface English / Hinglish string packs.
 *
 * Each module exports `{ en, hi }` with identical key names. They are merged
 * into the central dictionary, so `useT()` works exactly the same and a
 * missing Hinglish string still falls back to the complete English sentence.
 *
 * Same accuracy rules as `dictionary.ts`: never translate product names,
 * ingredient names or forms, doses, units, prices, pack sizes, certification
 * names or study references, and never strengthen a claim.
 */

import { pdpBody } from "./pdp";
import { kids } from "./kids";
import { blogChrome } from "./blog";
import { dietPlan } from "./dietPlan";
import { checkoutAccount } from "./checkoutAccount";
import { policies } from "./policies";
import { footer } from "./footer";
import { orderSuccess } from "./orderSuccess";
import { quizFlow } from "./quiz";

export const SECTIONS_EN = {
  ...pdpBody.en,
  ...kids.en,
  ...blogChrome.en,
  ...dietPlan.en,
  ...checkoutAccount.en,
  ...policies.en,
  ...footer.en,
  ...orderSuccess.en,
  ...quizFlow.en,
};
